<template>
    <v-responsive width="100%" max-width="1720" class="overflow-visible mx-auto">
        <v-row class="px-1" align="center">
            <v-col cols="auto" class="headline text-start">주문 관리</v-col>
            <v-spacer/>
            <v-col cols="auto">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>
        
        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-2 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text class="pb-0">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="filter.createdAt[0]" label="주문일자" type="date" persistent-placeholder hide-details />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="filter.createdAt[1]" label="주문일자" type="date" persistent-placeholder hide-details />
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-title="text" item-value="value" label="검색조건" persistent-placeholder hide-details @update:model-value="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" variant="text" elevation="0" @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-4 px-1" align="end">
            <v-col cols="auto" class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="white" class="text-green" @click="excel">
                    <v-icon icon="mdi-microsoft-excel" class="mr-2"></v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-simple-table class="elevation-1 mt-4">
            <thead>
                <tr>
                    <th style="min-width: 70px;" class="text-center">선택</th>
                    <th style="min-width: 170px;" class="text-center">주문일자</th>
                    <th style="min-width: 100px;" class="text-center">주문번호</th>
                    <th style="min-width: 100px;" class="text-center">결제방법</th>
                    <th style="min-width: 100px;" class="text-center">결제금액</th>
                    <th style="min-width: 120px;" class="text-center">구매자</th>
                    <th style="min-width: 120px;" class="text-center">수취인</th>
                    <th style="min-width: 100px;" class="text-center">구매번호</th>
                    <th style="min-width: 450px;" class="text-center">구매상품</th>
                    <th style="min-width: 100px;" class="text-center">구매수량</th>
                    <th style="min-width: 100px;" class="text-center">발행상태</th>
                    <th style="min-width: 100px;" class="text-center">결제상태</th>
                    <th style="min-width: 100px;" class="text-center">IP</th>
                    <th style="min-width: 100px;" class="text-center">PG</th>
                    <th style="min-width: 100px;" class="text-center">핀 발행 내역</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="purchase, index in purchases" :key="index">
                    <td><v-checkbox v-model="selected" :value="purchase" /></td>
                    <td class="text-center">{{ $dayjs(purchase.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</td>
                    <td class="text-center">{{ purchase.order.orderNo }}</td>
                    <td class="text-center">{{ purchase.order.paymentMethod }}</td>
                    <td class="text-center">{{ purchase.order.totalAmount }}</td>
                    <!-- <td class="text-center">{{ (purchase.salePrice * purchase.quantity ).format() }}원</td> -->
                    <td class="text-center">
                        <div>{{ purchase.order.buyer.name }} ({{ purchase.order.buyer.username || "비회원" }})</div>
                        <div>{{ purchase.order.buyer.phone }}</div>
                        <div>{{ purchase.order.buyer.email }}</div>
                    </td>
                    <td class="text-center">
                        <div>{{ purchase.order.receiver.name }}</div>
                        <div>{{ purchase.order.receiver.phone }}</div>
                        <div>{{ purchase.order.receiver.email }}</div>    
                    </td>
                    <td class="text-center">{{ purchase.purchaseNo }}</td>
                    <td>
                        <v-layout class="align-center">
                            <span class="mr-4">
                                <v-img :src="purchase.thumb?.src" width="56" height="56" contain/>
                            </span>
                            <div>
                                <div><b>{{ purchase.name }}</b></div>
                                <div>{{ purchase.salePrice.format() }}원</div>
                            </div>
                        </v-layout>
                    </td>
                    <td class="text-center">{{ purchase.quantity }}</td>
                    <td class="text-center">{{ purchase.status }}</td>
                    <td class="text-center">{{ purchase.paymentStatus }}</td>
                    <td class="text-center">{{ purchase.order.ip }}</td>
                    <td class="text-center">{{ purchase.order.paymentGateway }}</td>
                    <td class="text-center">
                        <v-icon size="20" @click="modal(purchase)">mdi-text-box-search</v-icon>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>

        <v-card class="mt-4 mx-1 mb-4">
            <v-card-text>
                <v-layout class="align-center">
                    <v-flex shrink>
                        <v-sheet width="100">발행관리</v-sheet>
                    </v-flex>
                    <v-flex>
                        <v-btn outlined color="primary" @click="resend()">문자 재발송</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider />
            <v-card-text>
                <v-layout class="align-center">
                    <v-flex shrink>
                        <v-sheet width="100">취소처리</v-sheet>
                    </v-flex>
                    <v-flex>
                        <v-btn outlined color="primary" @click="cancel()">판매취소</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider />
            <v-card-text>
                <v-layout class="align-center">
                    <v-flex shrink>
                        <v-sheet width="100">취소거절</v-sheet>
                    </v-flex>
                    <v-flex>
                        <v-btn outlined color="primary" @click="reject()">반려</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        
        <pin-dialog ref="pinDialog" />

    </v-responsive>
</template>

<script>
import api from "@/api";
import XLSX from "@/plugins/xlsx";

import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import PinDialog from "@/components/console/gshop2/purchase/pin-dialog.vue";

export default {
    components: {
        VDateField,
        PinDialog,
    },
    data(){
        return {
            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                createdAt: [ this.$route.query.createdAt?.[0] || '', this.$route.query.createdAt?.[1] || '' ],
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            selected: [],
            summary: { totalCount: 0 },
            purchases: [],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "주문번호", value: "order.orderNo" },
                { text: "구매번호", value: "purchaseNo" },
                { text: "구매자 이름", value: "order.buyer.name" },
                { text: "구매자 아이디", value: "order.buyer.username" },
                { text: "구매자 연락처", value: "order.buyer.phone" },
                { text: "구매자 이메일", value: "order.buyer.email" },
                { text: "수취인 이름", value: "order.receiver.name" },
                { text: "수취인 연락처", value: "order.receiver.phone" },
                { text: "수취인 이메일", value: "order.receiver.email" },
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, purchases } = await api.console.gshop2.purchases.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.purchases = purchases;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        
        modal(purchase){
            this.$refs.pinDialog.purchase = purchase;
            this.$refs.pinDialog.pins = purchase.pins;
            this.$refs.pinDialog.open();
        },

        // 판매취소
        async cancel(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("판매취소 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.gshop2.purchases.put({
                        _id: purchase._id,
                        status: "취소완료",
                        paymentStatus: "환불완료"
                    });
                }
                alert("판매취소 처리되었습니다");
                this.search(false);

                // 발송 문자 · 메일
                let orderMap = this.selected.reduce((orderMap, purchase) => {
                    orderMap.set(purchase._order, [...(orderMap.get(purchase._order) || []), purchase._id ])
                    return orderMap;
                }, new Map());

                for(let _order of orderMap.keys()){
                    api.console.common.receptions.send({
                        code: "cancel",
                        _order,
                        _purchases: orderMap.get(_order)
                    });
                }
            }
        },
        
        // 재발송
        async resend(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("문자를 재발송 하시겠습니까??")){
                // 발송 문자 · 메일
                let orderMap = this.selected.reduce((orderMap, purchase) => {
                    orderMap.set(purchase._order, [...(orderMap.get(purchase._order) || []), purchase._id ])
                    return orderMap;
                }, new Map());

                for(let _order of orderMap.keys()){
                    await api.console.gshop2.order.resend({ _id: _order });
                }

                alert("재발송 처리되었습니다");
                this.search(false);
            }
        },

        // 반려
        async reject(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("취소거절 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.gshop2.purchases.put({
                        _id: purchase._id,
                        status: "취소반려",
                    });
                }
                alert("취소거절 처리되었습니다");
                this.search(false);
            }
        },

        getCommissionAmount(purchase){
            const commissionOption = purchase?.giftcards?.[0]?.commission || {};
            const commission = +commissionOption?.[purchase?.order?.paymentMethod] || 0;
            const cutUnit = +commissionOption?.cutUnit || 1;

            return (Math.floor(purchase.salePrice * commission / (1000 * cutUnit)) * cutUnit * 10) * purchase.quantity;
        },

        async excel(){
            let { purchases } = await api.console.gshop2.purchases.gets({ headers: { limit: 0 }, params: this.filter });
            let rows = [];

            purchases.forEach(purchase => {
                let pno = purchase?.pins.map(pin => pin.pno)
                rows.push({ 
                    "주문일자": this.$dayjs(purchase?.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    "주문번호": purchase?.order?.orderNo,
                    "결제방법": purchase?.order?.paymentMethod,
                    // "결제금액": (purchase?.salePrice * purchase?.quantity)?.format(),
                    "결제금액": ((purchase?.salePrice * purchase?.quantity) + this.getCommissionAmount(purchase)).format(), 
                    "구매자 이름": purchase?.order?.buyer?.name || "",
                    "구매자 아이디": purchase?.order?.buyer?.username || "",
                    "구매자 연락처": purchase?.order?.buyer?.phone || "",
                    "수취인 연락처": purchase?.order?.receiver?.phone || "",
                    "구매번호": purchase?.purchaseNo,
                    // "구매상품": purchase?.name,
                    "구매상품": purchase?.name,
                    "구매상품 액면가": (purchase?.faceamt * purchase?.quantity)?.format(),
                    "구매상품 판매가": (purchase?.salePrice * purchase?.quantity)?.format(),
                    "구매상품 할인율": `${(((purchase?.option?.faceamt - purchase?.option?.salePrice) / purchase?.option?.faceamt) * 100)?.format()}%`,
                    "구매수량": purchase?.quantity?.format?.(),
                    "발행상태": purchase?.status,
                    "결제상태": purchase?.paymentStatus,
                    "ip": purchase?.order?.ip,
                    "pg": purchase?.order?.paymentGateway,
                    "핀발행내역": JSON.stringify(pno).replace("\[", "").replace("\]", ""),
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "주문내역");
            XLSX.writeFile(workbook, `주문내역${this.$dayjs().format('YYYYMMDD_HHmmss')}.xlsx`);
        }
    }
}
</script>